export default __webpack_public_path__ + "static/media/Head_4_Ear_2_C5.900f7dc5.svg";